import { render, staticRenderFns } from "./ViewExpense.vue?vue&type=template&id=2c53183a&scoped=true"
import script from "./ViewExpense.vue?vue&type=script&lang=js"
export * from "./ViewExpense.vue?vue&type=script&lang=js"
import style0 from "./ViewExpense.vue?vue&type=style&index=0&id=2c53183a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53183a",
  null
  
)

export default component.exports